var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isModal
        ? _c(
            "b-navbar",
            {
              attrs: {
                id: "header",
                type: "light",
                variant: "light",
                sticky: ""
              }
            },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "mr-2" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onBack()
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "chevron-left" }
                      }),
                      _vm._v("\n          Назад\n        ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-navbar-nav", { staticClass: "mx-2" }, [
                _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
              ]),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-row",
                    { attrs: { "align-v": "center" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.isDisabled || _vm.loading
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleSubmit()
                                }
                              }
                            },
                            [
                              _vm.loading
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "save" }
                              }),
                              _vm._v("\n              Сохранить\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("b-skeleton-wrapper", {
        attrs: { loading: _vm.isBusy },
        scopedSlots: _vm._u([
          {
            key: "loading",
            fn: function() {
              return [
                _c(
                  "b-card",
                  { attrs: { "no-body": "" } },
                  [
                    _c(
                      "b-tabs",
                      { attrs: { card: "" } },
                      [
                        _c("b-tab", {
                          attrs: { title: "Персональные данные", disabled: "" }
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: { title: "Платежные реквизиты", disabled: "" }
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: { title: "Файлы документов", disabled: "" }
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: { title: "Паспортные данные", disabled: "" }
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: { title: "Расходы", disabled: "" }
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: { title: "Связи", disabled: "" }
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: { title: "Последние Заявки", disabled: "" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { attrs: { "border-variant": "white" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { lg: "6" } },
                              [
                                _c(
                                  "b-card",
                                  { attrs: { "bg-variant": "light" } },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "mt-1" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "10%",
                                                height: "16%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "29%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                width: "100%",
                                                height: "15%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-2" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "6%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "45%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-2" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "6%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "45%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-2 pt-1" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "17%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "45%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-2" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "9%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "45%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-1 pt-1" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "10%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "45%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "16%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "45%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { lg: "6" } },
                              [
                                _c(
                                  "b-card",
                                  { attrs: { "bg-variant": "light" } },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { staticClass: "mb-2 mt-2" },
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "7%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "44%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "21%",
                                                height: "16%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "29%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              staticClass: "mb-0",
                                              attrs: {
                                                width: "40%",
                                                height: "15%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-2" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "27%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "44%"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "65%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "44%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-2" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "8%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "43%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-2" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "12%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "44%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-2" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "17%",
                                                height: "16%x"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "29%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                width: "100%",
                                                height: "15%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-4" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "17%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "107%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "b-card",
                  { attrs: { "no-body": "" } },
                  [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.handleSubmit.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c(
                          "b-tabs",
                          { attrs: { card: "" } },
                          [
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  title: "Персональные данные",
                                  active: ""
                                }
                              },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-2",
                                        attrs: { lg: "6" }
                                      },
                                      [
                                        _c(
                                          "b-card",
                                          {
                                            staticClass: "h-100",
                                            attrs: { "bg-variant": "light" }
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-phone",
                                                  label: _vm.$t(
                                                    "message.workers.modal.phoneInput"
                                                  ),
                                                  description:
                                                    "Уникальный для каждого исполнителя. Если телефон не начинается с +7 укажите это в Примечании."
                                                }
                                              },
                                              [
                                                _c(
                                                  "b-input-group",
                                                  {
                                                    attrs: {
                                                      size: "sm",
                                                      prepend: "+7"
                                                    }
                                                  },
                                                  [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        size: "sm",
                                                        type: "text",
                                                        disabled:
                                                          _vm.isDisabled,
                                                        placeholder: _vm.$t(
                                                          "message.workers.modal.phonePlaceholder"
                                                        ),
                                                        state: _vm.phoneState
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.newItem.phone,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.newItem,
                                                            "phone",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "newItem.phone"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-invalid-feedback",
                                                      {
                                                        attrs: {
                                                          state: _vm.phoneState
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              _vm.phoneInvalidFeedback
                                                            ) +
                                                            "\n                          "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-name",
                                                  label: "ФИО"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    state: _vm.getFieldState(
                                                      "name"
                                                    ),
                                                    placeholder: _vm.$t(
                                                      "message.workers.modal.namePlaceholder"
                                                    )
                                                  },
                                                  model: {
                                                    value: _vm.newItem.name,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newItem.name"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-inn",
                                                  label: "ИНН"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder: "Введите ИНН"
                                                  },
                                                  model: {
                                                    value: _vm.newItem.inn,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "inn",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newItem.inn"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-employment-type",
                                                  label: "Тип занятости"
                                                }
                                              },
                                              [
                                                _c(
                                                  "b-form-select",
                                                  {
                                                    attrs: {
                                                      size: "sm",
                                                      disabled: _vm.isDisabled,
                                                      state: _vm.getFieldState(
                                                        "employment_type"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newItem
                                                          .employment_type,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newItem,
                                                          "employment_type",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newItem.employment_type"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { disabled: "" },
                                                        domProps: {
                                                          value: null
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Выберите тип занятости"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.employment_types,
                                                      function(option) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value: option.id
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  option.name
                                                                ) +
                                                                "\n                          "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-snils",
                                                  label: "СНИЛС"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder: "Введите СНИЛС"
                                                  },
                                                  model: {
                                                    value: _vm.newItem.snils,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "snils",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newItem.snils"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { cols: "6" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          id: "group-age",
                                                          label: "Возраст"
                                                        }
                                                      },
                                                      [
                                                        _c("b-form-input", {
                                                          attrs: {
                                                            size: "sm",
                                                            type: "text",
                                                            disabled:
                                                              _vm.isDisabled,
                                                            placeholder:
                                                              "Введите возраст"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.newItem.age,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.newItem,
                                                                "age",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "newItem.age"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { cols: "6" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          id: "group-age",
                                                          label: "Пол"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b-form-select",
                                                          {
                                                            attrs: {
                                                              size: "sm",
                                                              disabled:
                                                                _vm.isDisabled
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.newItem.sex,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.newItem,
                                                                  "sex",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "newItem.sex"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "option",
                                                              {
                                                                attrs: {
                                                                  disabled: ""
                                                                },
                                                                domProps: {
                                                                  value: null
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Выберите пол"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "option",
                                                              {
                                                                domProps: {
                                                                  value: true
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Мужчина"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "option",
                                                              {
                                                                domProps: {
                                                                  value: false
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Женщина"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-passport-type",
                                                  label: "Гражданство"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder: _vm.$t(
                                                      "message.workers.modal.passport_typePlaceholder"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.passport_type,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "passport_type",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.passport_type"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "align-items-center"
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          id: "group-status",
                                                          label: "Статус"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "worker-status-select",
                                                          {
                                                            attrs: {
                                                              id:
                                                                _vm.newItem
                                                                  .status_id,
                                                              "is-disabled":
                                                                _vm.isDisabled,
                                                              "drop-up": ""
                                                            },
                                                            on: {
                                                              onSelect:
                                                                _vm.onSelectWorkerStatus
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        staticClass: "mt-3",
                                                        attrs: {
                                                          disabled:
                                                            _vm.isDisabled,
                                                          size: "md"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newItem.active,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newItem,
                                                              "active",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "newItem.active"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Активен / не активен"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-2",
                                        attrs: { lg: "6" }
                                      },
                                      [
                                        _c(
                                          "b-card",
                                          {
                                            staticClass: "h-100",
                                            attrs: { "bg-variant": "light" }
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-town",
                                                  label: "Город"
                                                }
                                              },
                                              [
                                                _c("town-select", {
                                                  attrs: {
                                                    id: _vm.newItem.town_id,
                                                    "is-disabled":
                                                      _vm.isDisabled,
                                                    state: _vm.getFieldState(
                                                      "town_id"
                                                    )
                                                  },
                                                  on: {
                                                    onSelect: _vm.onSelectTown
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-address",
                                                  label: "Адрес проживания",
                                                  description:
                                                    "Адрес текущего проживания исполнителя"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder: _vm.$t(
                                                      "message.workers.modal.addressPlaceholder"
                                                    )
                                                  },
                                                  model: {
                                                    value: _vm.newItem.address,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "address",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.address"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          id:
                                                            "group-worker-source",
                                                          label: "Источник"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "worker-source-select",
                                                          {
                                                            attrs: {
                                                              id:
                                                                _vm.newItem
                                                                  .worker_source_id,
                                                              "is-disabled":
                                                                _vm.isDisabled,
                                                              state: _vm.getFieldState(
                                                                "worker_source_id"
                                                              )
                                                            },
                                                            on: {
                                                              onSelect:
                                                                _vm.onSelectWorkerSource
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          id:
                                                            "group-worker-source-comment",
                                                          label:
                                                            "Источник комментарий"
                                                        }
                                                      },
                                                      [
                                                        _c("b-form-input", {
                                                          attrs: {
                                                            type: "text",
                                                            size: "sm",
                                                            disabled:
                                                              _vm.isDisabled
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.newItem
                                                                .worker_source_comment,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.newItem,
                                                                "worker_source_comment",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "newItem.worker_source_comment"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-skills",
                                                  label: _vm.$t(
                                                    "message.workers.modal.skillInput"
                                                  )
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder: _vm.$t(
                                                      "message.workers.modal.skillPlaceholder"
                                                    )
                                                  },
                                                  model: {
                                                    value: _vm.newItem.skill,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "skill",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newItem.skill"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-ready",
                                                  label: _vm.$t(
                                                    "message.workers.modal.readyInput"
                                                  )
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder: _vm.$t(
                                                      "message.workers.modal.readyPlaceholder"
                                                    )
                                                  },
                                                  model: {
                                                    value: _vm.newItem.ready,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "ready",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newItem.ready"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-level-efficiency",
                                                  label: "Уровень КПД",
                                                  description:
                                                    "Высокий - все в норме. Средний - внимание, есть риск. Низкий - проблемный. При необходимости добавьте Примечание."
                                                }
                                              },
                                              [
                                                _c("b-form-select", {
                                                  staticClass: "mb-1 mr-2",
                                                  attrs: {
                                                    size: "sm",
                                                    disabled: _vm.isDisabled,
                                                    options:
                                                      _vm.levelEfficiencyOptions
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem
                                                        .level_efficiency,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "level_efficiency",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.level_efficiency"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                staticClass: "mb-0",
                                                attrs: {
                                                  id: "group-description",
                                                  label: _vm.$t(
                                                    "message.workers.modal.descriptionInput"
                                                  )
                                                }
                                              },
                                              [
                                                _c("b-form-textarea", {
                                                  attrs: {
                                                    size: "sm",
                                                    disabled: _vm.isDisabled,
                                                    placeholder: _vm.$t(
                                                      "message.workers.modal.descriptionPlaceholder"
                                                    ),
                                                    rows: 4,
                                                    "max-rows": 6
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.description,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.description"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              { attrs: { title: "Платежные реквизиты" } },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { lg: "6" } },
                                      [
                                        _c(
                                          "b-card",
                                          { attrs: { "bg-variant": "light" } },
                                          [
                                            _c("b-table", {
                                              ref: "paymentTable",
                                              attrs: {
                                                items: _vm.paymentItems,
                                                fields: _vm.paymentFields,
                                                "select-mode": "single",
                                                responsive: "sm",
                                                selectable: "",
                                                selectedVariant: "success",
                                                "thead-class": "hidden_header"
                                              },
                                              on: {
                                                "row-selected":
                                                  _vm.onPaymentRowSelected
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "cell(selected)",
                                                  fn: function(ref) {
                                                    var rowSelected =
                                                      ref.rowSelected
                                                    return [
                                                      rowSelected
                                                        ? [
                                                            _c(
                                                              "font-awesome-icon",
                                                              {
                                                                attrs: {
                                                                  icon: [
                                                                    "far",
                                                                    "square-check"
                                                                  ]
                                                                }
                                                              }
                                                            )
                                                          ]
                                                        : [
                                                            _c(
                                                              "font-awesome-icon",
                                                              {
                                                                attrs: {
                                                                  icon: [
                                                                    "far",
                                                                    "square"
                                                                  ]
                                                                }
                                                              }
                                                            )
                                                          ]
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "cell(details)",
                                                  fn: function(row) {
                                                    return [
                                                      _c(
                                                        "b-card",
                                                        {
                                                          attrs: {
                                                            "bg-variant":
                                                              "light"
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "\n                              " +
                                                                _vm._s(
                                                                  row.item.name
                                                                ) +
                                                                "\n                            "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          row.item.id === 1
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "group-payments-sbp-phone-number",
                                                                        label:
                                                                          "Телефон"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          attrs: {
                                                                            size:
                                                                              "sm",
                                                                            type:
                                                                              "text",
                                                                            readonly:
                                                                              _vm.isDisabled
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .newItem
                                                                                .payments_sbp
                                                                                .sbp_phone,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .newItem
                                                                                  .payments_sbp,
                                                                                "sbp_phone",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "newItem.payments_sbp.sbp_phone"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "group-payments-sbp-recipient-name",
                                                                        label:
                                                                          "ФИО получателя"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          attrs: {
                                                                            size:
                                                                              "sm",
                                                                            type:
                                                                              "text",
                                                                            readonly:
                                                                              _vm.isDisabled
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .newItem
                                                                                .payments_sbp
                                                                                .recipient_name,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .newItem
                                                                                  .payments_sbp,
                                                                                "recipient_name",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "newItem.payments_sbp.recipient_name"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          row.item.id === 2
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "group-payments-card-card-number",
                                                                        label: _vm.$t(
                                                                          "message.workers.modal.cart_numberInput"
                                                                        )
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          attrs: {
                                                                            size:
                                                                              "sm",
                                                                            type:
                                                                              "text",
                                                                            readonly:
                                                                              _vm.isDisabled
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .newItem
                                                                                .payments_card
                                                                                .card_number,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .newItem
                                                                                  .payments_card,
                                                                                "card_number",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "newItem.payments_card.card_number"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          row.item.id === 3
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "group-pay-account-number",
                                                                        label:
                                                                          "Номер счёта"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          attrs: {
                                                                            size:
                                                                              "sm",
                                                                            type:
                                                                              "text",
                                                                            readonly:
                                                                              _vm.isDisabled
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .newItem
                                                                                .payments_req
                                                                                .account_number,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .newItem
                                                                                  .payments_req,
                                                                                "account_number",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "newItem.payments_req.account_number"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "group-payments-req-bik",
                                                                        label:
                                                                          "БИК"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          attrs: {
                                                                            size:
                                                                              "sm",
                                                                            type:
                                                                              "text",
                                                                            readonly:
                                                                              _vm.isDisabled
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .newItem
                                                                                .payments_req
                                                                                .bik,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .newItem
                                                                                  .payments_req,
                                                                                "bik",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "newItem.payments_req.bik"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          "group-payments-req-recipient-name",
                                                                        label:
                                                                          "ФИО получателя"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          attrs: {
                                                                            size:
                                                                              "sm",
                                                                            type:
                                                                              "text",
                                                                            readonly:
                                                                              _vm.isDisabled
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .newItem
                                                                                .payments_req
                                                                                .recipient_name,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .newItem
                                                                                  .payments_req,
                                                                                "recipient_name",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "newItem.payments_req.recipient_name"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ])
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              { attrs: { title: "Файлы документов" } },
                              [
                                _c(
                                  "b-card",
                                  { attrs: { "bg-variant": "light" } },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { lg: "6" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-passport",
                                                  label: _vm.$t(
                                                    "message.workers.modal.passport_urlInput"
                                                  )
                                                }
                                              },
                                              [
                                                !_vm.isShowFile(_vm.newItem)
                                                  ? _c("b-form-file", {
                                                      ref: "fileinput",
                                                      attrs: {
                                                        size: "sm",
                                                        placeholder: _vm.$t(
                                                          "message.workers.modal.passport_urlPlaceholder"
                                                        ),
                                                        disabled: _vm.isDisabled
                                                      },
                                                      model: {
                                                        value: _vm.passportFile,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.passportFile = $$v
                                                        },
                                                        expression:
                                                          "passportFile"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isShowFile(_vm.newItem)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                          "justify-content":
                                                            "left"
                                                        },
                                                        attrs: {
                                                          id:
                                                            "input-passport-file"
                                                        }
                                                      },
                                                      [
                                                        _c("b-img", {
                                                          staticStyle: {
                                                            cursor: "pointer"
                                                          },
                                                          attrs: {
                                                            thumbnail: "",
                                                            width: "100",
                                                            height: "100",
                                                            src: _vm.previewUrl
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.downloadFile
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        !_vm.isDisabled
                                                          ? _c(
                                                              "b-btn",
                                                              {
                                                                staticClass:
                                                                  "mx-2 md-0",
                                                                attrs: {
                                                                  variant:
                                                                    "danger",
                                                                  size: "sm"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onRemove(
                                                                      _vm.newItem
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.common.searchClear"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              { attrs: { title: "Паспортные данные" } },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { lg: "6" } },
                                      [
                                        _c(
                                          "b-card",
                                          { attrs: { "bg-variant": "light" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-passport-series",
                                                  label: "Серия"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder: "Введите серию"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.passport
                                                        .passport_series,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem.passport,
                                                        "passport_series",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.passport.passport_series"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-passport-number",
                                                  label: "Номер"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder: "Введите номер"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.passport
                                                        .passport_number,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem.passport,
                                                        "passport_number",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.passport.passport_number"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id:
                                                    "group-passport-birthdate",
                                                  label: "Дата рождения"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "date",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.passport
                                                        .birth_date,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem.passport,
                                                        "birth_date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.passport.birth_date"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id:
                                                    "group-passport-birthplace",
                                                  label: "Место рождения"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder:
                                                      "Введите место рождения"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.passport
                                                        .birth_place,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem.passport,
                                                        "birth_place",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.passport.birth_place"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id:
                                                    "group-passport-issued-by",
                                                  label: "Кем выдан"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder:
                                                      "Введите Кем выдан"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.passport
                                                        .issued_by,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem.passport,
                                                        "issued_by",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.passport.issued_by"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id:
                                                    "group-passport-issue-date",
                                                  label: "Дата выдачи"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "date",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.passport
                                                        .issue_date,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem.passport,
                                                        "issue_date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.passport.issue_date"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id:
                                                    "group-passport-department-code",
                                                  label: "Код подразделения"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder:
                                                      "Введите Код подразделения"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.passport
                                                        .department_code,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem.passport,
                                                        "department_code",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.passport.department_code"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id:
                                                    "group-passport-registration-address",
                                                  label: "Адрес регистрации"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "text",
                                                    disabled: _vm.isDisabled,
                                                    placeholder:
                                                      "Введите Адрес регистрации"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.passport
                                                        .registration_address,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem.passport,
                                                        "registration_address",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.passport.registration_address"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.isVisibleForRole()
                              ? _c(
                                  "b-tab",
                                  { attrs: { title: "Расходы" } },
                                  [
                                    _c("worker-costs", {
                                      ref: "worker_costs",
                                      attrs: { "is-disabled": _vm.isDisabled }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isVisibleForRole()
                              ? _c(
                                  "b-tab",
                                  { attrs: { title: "Связи" } },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { lg: "6", md: "12" } },
                                          [
                                            _c(
                                              "b-list-group",
                                              { attrs: { size: "sm" } },
                                              [
                                                _c(
                                                  "b-list-group-item",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-content-between align-items-center",
                                                    style: {
                                                      backgroundColor: "#e9ecef"
                                                    },
                                                    attrs: {
                                                      variant: _vm.getStaffVariant()
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        Штатный сотрудник\n                        "
                                                    ),
                                                    _c(
                                                      "div",
                                                      [
                                                        _c("staff-select", {
                                                          ref: "staff_select",
                                                          on: {
                                                            onSelect:
                                                              _vm.updateStaffId
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-list-group-item",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-content-between align-items-center",
                                                    style: {
                                                      backgroundColor: "#f8f9fa"
                                                    }
                                                  },
                                                  [
                                                    _c("div", [
                                                      _vm._v(
                                                        "\n                          Баланс ПРО\n                          "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _vm.workerIntegration !=
                                                      null
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-secondary text-small"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              Идентификатор " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .workerIntegration
                                                                      .balans_pro_id
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ]
                                                          )
                                                        : _c("span", {
                                                            staticClass:
                                                              "text-secondary text-small"
                                                          })
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      [
                                                        _vm.workerIntegration ==
                                                        null
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex justify-content-end align-items-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    attrs: {
                                                                      id:
                                                                        "input-inn",
                                                                      size:
                                                                        "sm",
                                                                      type:
                                                                        "text",
                                                                      disabled:
                                                                        _vm.isDisabled,
                                                                      placeholder:
                                                                        "Введите ИНН для поиска"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.innIntegration,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.innIntegration = $$v
                                                                      },
                                                                      expression:
                                                                        "innIntegration"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "organization-select",
                                                                  {
                                                                    ref:
                                                                      "organization_select",
                                                                    staticClass:
                                                                      "ml-2",
                                                                    staticStyle: {
                                                                      width:
                                                                        "300px"
                                                                    },
                                                                    attrs: {
                                                                      id:
                                                                        "input-org-select",
                                                                      "initial-id": 0
                                                                    },
                                                                    on: {
                                                                      onSelect:
                                                                        _vm.onSelectOrg
                                                                    }
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "b-button",
                                                                  {
                                                                    staticClass:
                                                                      "ml-2",
                                                                    attrs: {
                                                                      size:
                                                                        "sm",
                                                                      variant:
                                                                        "primary"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.findBalansProWorkerHandler()
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              Связать\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.workerIntegration !=
                                                        null
                                                          ? _c(
                                                              "b-button",
                                                              {
                                                                attrs: {
                                                                  size: "sm",
                                                                  variant:
                                                                    "danger"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.prepareUnlinkBalansProWorkerHandler()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            Отвязать\n                          "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              { attrs: { title: "Последние Заявки" } },
                              [
                                _c(
                                  "b-card",
                                  {
                                    staticClass: "mx-0",
                                    attrs: { "no-body": "" }
                                  },
                                  [
                                    _c("b-table", {
                                      staticClass: "mb-0 text-small",
                                      attrs: {
                                        striped: "",
                                        small: "",
                                        responsive: "",
                                        "show-empty": "",
                                        "empty-text": _vm.$t(
                                          "message.common.emptyTable"
                                        ),
                                        items: _vm.lastTasks,
                                        fields: _vm.lastTasksFields,
                                        "head-variant": "light"
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "cell(start_date)",
                                          fn: function(row) {
                                            return [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.formatTableDateTime(
                                                      row.item.start_date
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43acf068", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43acf068","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workers/Worker.vue
// module id = null
// module chunks = 